export const JOIN_TO_UNIT = 'join_unit/JOIN_TO_UNIT'

export function joinToUnit(unitServerId, peripheryId) {
    const webToClient = {
        handler: 'joinToUnitOnOtherPeriphery',
        params: {
            unitServerId,
            peripheryId,
        },
    }

    return {
        type: JOIN_TO_UNIT,
        payload: {},
        meta: { webToClient },
    }
}



// WEBPACK FOOTER //
// ./state/actions/join_unit.js